(function ($) {
    // Временно отключаем, все равно не работает
    /*require('./modules/sentry/init.js');*/

    require('./modules/common/helpers.js');

// скрипты верстки
    $(document).ready(function () {
        // здесь будет подключение скриптов разработчиков по модулям
        require('./modules/bannerSlider/bannerSlider.js');

        require('./modules/callbackForm/callbackForm');

        require('./modules/city/citySwitcher.js');

        require('./modules/clinic/clinicGallery.js');

        require('./modules/consultationForm/consultationForm');

        require('./modules/coupon/couponsList.js');

        require('./modules/doctor/doctorItem.js');
        require('./modules/doctor/doctorsList.js');
        require('./modules/doctor/doctorsListClinic.js');
        require('./modules/doctor/doctorsListMain.js');

        require('./modules/feedback/feedbackForm.js');
        require('./modules/feedback/feedbackList.js');

        require('./modules/map/mapClinicDetail.js');
        require('./modules/map/mapClinics.js');

        require('./modules/search/searchServiceDoctor.js');

        require('./modules/service/analyzesList');
        require('./modules/service/medicalProgramsList');
        require('./modules/service/servicesDoctorsList.js');
        require('./modules/service/servicesList.js');

        require('./modules/legalInformation/legalInformationItem.js');

        require('./modules/license/licensesFilter.js');

        require('./modules/work/work.js');
    });
let wrapper = document.querySelector('.js-recording-form')
let form = document.querySelector('.js-callback-form')
let clinicForm = document.querySelector('.js-clinic_name_Callback')
const csrfToken = getCookie('CSRF-TOKEN');

    let doctorPage = document.querySelector('#doctor-item-module')
    let doctorPageBtn = document.querySelector('.js-scroll-to-timetable')

    if (doctorPageBtn) {
        let dr_clinics_ids = [19, 17, 18, 25, 23, 24, 22, 21, 20, 15, 16]

    if (dr_clinics_ids.includes(parseInt(doctorPageBtn.dataset.clinicsId)) || !doctorPageBtn.dataset.signUp) {
        doctorPageBtn.textContent = 'Записаться онлайн'
        doctorPageBtn.classList.add('js-open-popup')
        doctorPageBtn.dataset.popupContent = '#callback-popup'
        doctorPageBtn.classList.remove('js-scroll-to-timetable')
        doctorPageBtn.onclick = function () {
            let data = {
                'clinic_id': doctorPageBtn.dataset.clinicsId,
                'specialization_id': doctorPageBtn.dataset.specialisation
            }
            document.querySelector('.js-clinic_name_Callback').value = doctorPageBtn.dataset.clinicName
            document.querySelector('.js-doctor-fio__Callback').value = document.querySelector('.block-info__right > h1').textContent

            }
        }
    }

    if (wrapper) {
        let isClicked = true
        wrapper.addEventListener('mousemove', () => {
            let clinics = document.querySelectorAll('.js-choose-clinic')
            clinics.forEach(item => {
                let dr_clinics_ids = [19, 17, 18, 25, 23, 24, 22, 21, 20, 15, 16]
                item.onclick = function () {
                    clinicForm.value = item.dataset.clinicName;
                }
                if (dr_clinics_ids.includes(parseInt(item.dataset.clinicId))) {
                    item.classList.add('js-open-popup')
                    item.dataset.popupContent = '#callback-popup'
                    item.classList.remove('js-choose-clinic')

                item.onclick = function () {
                    let data = {
                        'clinic_id': item.dataset.clinicId,
                        'specialization_id': item.dataset.specialisationChoose
                    }
                    document.querySelector('.js-clinic_name_Callback').value = item.dataset.clinicName
                    let options
                    fetch('/test-api', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        body: JSON.stringify(data)
                    })
                        .then(response => response.json())
                        .then((response) => {
                            options = response
                            if(document.querySelector('.callback-form__title').nextElementSibling.classList.contains('js-custom-doctor-select')){
                                let old_select = document.querySelector('.callback-form__title').nextElementSibling
                                let old_span = document.querySelector('.callback-form__title').nextElementSibling.nextElementSibling
                                old_span.parentElement.removeChild(old_span)
                                old_select.parentElement.removeChild(old_select)
                            }
                            let selectDoctors = document.createElement('select')
                            selectDoctors.classList.add('js-custom-doctor-select')
                            selectDoctors.name = 'doctor-callback'
                            for (let i = 0; i < options.length; i++) {
                                let optionDoctor = document.createElement('option')
                                optionDoctor.value = options[i].id
                                optionDoctor.textContent = options[i].fio
                                selectDoctors.append(optionDoctor);
                            }
                            form.querySelector('.callback-form__title').after(selectDoctors)
                            $('.js-custom-doctor-select').select2();
                            document.querySelector('.js-doctor-fio__Callback').value = document.querySelector('.select2-selection__rendered').textContent
                            selectDoctors.onchange = function () {
                                document.querySelector('.js-doctor-fio__Callback').value = document.querySelector('.select2-selection__rendered').textContent
                            }
                        })

                    }
                }
                var params = window
                    .location
                    .search
                    .replace('?', '')
                    .split('&')
                    .reduce(
                        function (p, e) {
                            var a = e.split('=');
                            p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                            return p;
                        },
                        {}
                    );
                if (params['clinic_id'] &&
                    isClicked
                )
                {
                    if (params['clinic_id'] === item.dataset.clinicId) {
                        item.click();
                        isClicked = false

                }
            }
        })
        let doctorRow = document.querySelectorAll('.doctor-list__item');
        doctorRow.forEach(item => {
            item.addEventListener('mouseover', (e) => {
                let fio = item.dataset.doctorSurname + ' ' + item.dataset.doctorName + ' ' + item.dataset.doctorPatronymic
                let callBtns = document.querySelectorAll('.js-open-popup');
                callBtns.forEach(btn => {
                    btn.onclick = function () {
                        setTimeout(() => {
                            let fioInput = document.querySelector('.js-doctor-fio__Callback')
                            fioInput.value = fio
                        }, 100)
                    }
                })
            })
        })
    })
}

//Кнопка развернуть
    function toggleBtn(buttons, hiddenItem, letter, alphBody) {
        let _alphabetBody = document.querySelectorAll(alphBody);

        _alphabetBody.forEach(item => {
            let _button = item.querySelector(buttons),
                _hidden = item.querySelectorAll(hiddenItem);
            _button.onclick = function () {
                _hidden.forEach(item => {
                    item.classList.toggle('hidden');
                })
            }
        })
    }

//Живой поиск
    let hiddenItemsLoaded = document.querySelectorAll('.letter-chunk.hidden');
    const alphabetInput = document.querySelector('.alphabet-search input')
    if(alphabetInput !== null){
        alphabetInput.oninput = function(){
            let val = this.value.trim().toLowerCase();
            let alphabetItems = document.querySelectorAll('.letter-chunk li[data-disease]');
            let hiddenItems = document.querySelectorAll('.letter-chunk.hidden');
            let _showBtns = document.querySelectorAll('.show-more');
            if (val != '') {
                alphabetItems.forEach(function(elem){
                    if(elem.innerText.toLowerCase().search(val) == -1) {
                        elem.classList.add('hidden');
                        hiddenItemsLoaded.forEach(item => {
                            item.classList.remove('hidden');
                        });
                        _showBtns.forEach(itemb => {
                            itemb.classList.add('hidden');
                        })
                    }else {
                        elem.classList.remove('hidden');
                        //let str = elem.innerText;
                        //elem.innerHTML = insertMark(str, elem.innerText.search(val), val.length);
                    }
                });

            }else if(val == '') {
                hiddenItemsLoaded.forEach((item,i )=> {
                    item.classList.add('hidden');
                });
                alphabetItems.forEach(function(elem){
                    elem.classList.remove('hidden');
                });
                _showBtns.forEach(itemb => {
                    itemb.classList.remove('hidden');
                });
            }
            else {
                alphabetItems.forEach(function(elem){
                    elem.classList.remove('hidden');
                });
            }
            //скрываем блоки, в которых нет совпадений со значением инпута
            let allBlocks = document.querySelectorAll('.diseases-list__letter');

            allBlocks.forEach(block=>{
                let d = block.querySelectorAll('li');
                let all_h = true;
                /*  console.log(d.length); */
                d.forEach(ttm=>{

                    if(ttm.classList.value !== 'hidden'){
                        all_h = false;
                    }
                })
                /*  console.log(all_h); */
                if(all_h){
                    block.classList.add('hidden');
                }else{
                    block.classList.remove('hidden')
                }
            })
        }
    }


    if (typeof $.fn.slick === 'function') {
        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav',

        });

        $('.slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: true,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: '0',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
    else {
        console.warn('Плагин для Slick отсутствует');
    }

    /*function insertMark(string, pos, len) {
    return string.slice(0, pos) + '<mark>' + string.slice(pos, pos + len) + '</mark>' + string.slice(pos + len);
    }*/

    toggleBtn('.show-more', '.letter-chunk.hidden', '.diseases-list__letter h3', '.diseases-list__letter');
})(jQuery);
